module.exports = __webpack_public_path__ + "static/media/Human_char1b.94958b63.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Characters/Human_char1b.jpg
// module id = 193
// module chunks = 0